import React from 'react';
import styled from 'styled-components';

const Window = props => (
	<g {...props}>
		<defs>
			<linearGradient x1="50%" y1="96.5182442%" x2="50%" y2="8.1511922%" id="linearGradient-1">
				<stop stopColor="#2F1B88" offset="0%"></stop>
				<stop stopColor="#160C4F" offset="100%"></stop>
			</linearGradient>
			<path d="M74.1512603,187.577954 C91.3510444,179.038877 103.15757,161.416313 103.15757,141.06245 C103.15757,116.612379 86.1207454,96.1035752 63.1638792,90.5469462 C70.232573,87.0375929 78.2121938,85.0624502 86.6575697,85.0624502 C115.652519,85.0624502 139.15757,108.343643 139.15757,137.06245 C139.15757,165.781257 115.652519,189.06245 86.6575697,189.06245 C82.3477881,189.06245 78.1592979,188.548086 74.1512603,187.577954 Z" id="path-2"></path>
			<filter x="-47.4%" y="-34.6%" width="194.7%" height="169.2%" filterUnits="objectBoundingBox" id="filter-3">
				<feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
				<feGaussianBlur stdDeviation="12" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
				<feColorMatrix values="0 0 0 0 0.990433673   0 0 0 0 0.552819389   0 0 0 0 0.0376532057  0 0 0 0.470872962 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
			</filter>
		</defs>
		<g id="Artboard" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(620, 67)">
			<rect id="Window-Frame-Night" stroke="#3F2E89" strokeWidth="8" fill="url(#linearGradient-1)" x="23" y="26" width="218" height="270"></rect>
			<rect id="Window-Frame-Day" stroke="#FFFFFF" strokeWidth="8" fill="#F2F2F2" x="23" y="26" width="218" height="270"></rect>
			<circle id="Oval" fill="#F8F8F7" cx="198.75" cy="71.75" r="2.75"></circle>
			<circle id="Oval" fill="#F8F8F7" cx="163.75" cy="183.75" r="1.75"></circle>
			<circle id="Oval" fill="#F8F8F7" cx="94.75" cy="251.75" r="1.75"></circle>
			<circle id="Oval" fill="#F8F8F7" cx="222.75" cy="281.75" r="1.75"></circle>
			<circle id="Oval" fill="#F8F8F7" cx="217.25" cy="100.25" r="1.25"></circle>
			<circle id="Oval" fill="#F8F8F7" cx="80.25" cy="211.25" r="1.25"></circle>
			<circle id="Oval" fill="#F8F8F7" cx="59.25" cy="118.25" r="1.25"></circle>
			<g id="Moon" transform="translate(101.160724, 137.062450) rotate(15.000000) translate(-101.160724, -137.062450) ">
				<use fill="black" fillOpacity="1" filter="url(#filter-3)" href="#path-2"></use>
				<use fill="#FFB053" fillRule="evenodd" href="#path-2"></use>
			</g>
			<circle id="Sun" fill="#FFB053" cx="90" cy="130" r="50"></circle>
			<path id="Window-Panel" d="M26.5,161 L236,161" stroke="#3F2E89" strokeWidth="7" fill="#191148" strokeLinecap="square" transform="translate(131.250000, 161.000000) rotate(-360.000000) translate(-131.250000, -161.000000) "></path>
			<path id="Window-Panel" d="M1.5,163 L261,163" stroke="#3F2E89" strokeWidth="7" fill="#191148" strokeLinecap="square" transform="translate(131.250000, 163.000000) rotate(-270.000000) translate(-131.250000, -163.000000) "></path>
		</g>
	</g>
);

const StyledWindow = styled(Window)`
	#Window-Panel {
		stroke: ${({ theme }) => theme.hero.windowPanels};
		transition: stroke ${props => props.theme.theming.nightDayTransitionDuration} ease;
	}

	#Window-Frame-Night, #Moon {
		opacity: ${({ theme }) => theme.hero.visibleDuringNight};
		transition: opacity ${props => props.theme.theming.nightDayTransitionDuration} ease;
	}

	#Window-Frame-Day, #Sun {
		opacity: ${({ theme }) => theme.hero.visibleDuringDay};
		transition: opacity ${props => props.theme.theming.nightDayTransitionDuration} ease;
	}
`;

export default StyledWindow;
